export default __webpack_public_path__ + "static/media/icon-facebook-2.fa38f356.svg";